import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Section } from './ui/Section';
export const Guarantee = () => {
  return <Section background="celeste" className="py-12 md:py-16" data-id="element-108">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-celeste-100 flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-109">
        <div className="shrink-0" data-id="element-110">
          <div className="w-24 h-24 md:w-32 md:h-32 bg-celeste-50 rounded-full flex items-center justify-center" data-id="element-111">
            <ShieldCheck className="w-12 h-12 md:w-16 md:h-16 text-celeste-600" data-id="element-112" />
          </div>
        </div>
        <div className="text-center md:text-left" data-id="element-113">
          <h2 className="text-2xl md:text-3xl font-extrabold text-stone-900 mb-4" data-id="element-114">
            🛡️ GARANTÍA 7 DÍAS SIN PREGUNTAS
          </h2>
          <p className="text-lg text-stone-600 font-medium mb-4" data-id="element-115">
            Abrís los tomos. Los usás en el aula.{' '}
            <br className="hidden md:block" data-id="element-116" />
            Si en 7 días no es exactamente lo que esperabas:
          </p>
          <div className="bg-emerald-50 text-emerald-800 font-bold px-4 py-3 rounded-xl inline-block mb-4" data-id="element-117">
            ✅ Devolución del 100% de tu dinero
          </div>
          <p className="text-stone-500 font-medium" data-id="element-118">
            Sin formularios. Sin drama. Sin explicaciones. <br data-id="element-119" />
            <span className="text-stone-800 font-bold" data-id="element-120">
              Tasa de devoluciones real: menos del 1%
            </span>{' '}
            <br data-id="element-121" />
            Porque el material habla solo.
          </p>
        </div>
      </div>
    </Section>;
};